import { render, staticRenderFns } from "./DashboardLanding.vue?vue&type=template&id=b0b51eb6&"
import script from "./DashboardLanding.vue?vue&type=script&lang=js&"
export * from "./DashboardLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports